import { AvatarSize } from "mapiq-molecules";

const AvatarSizes: Record<AvatarSize | "default", { size: number; fontSize: number }> = {
  small: {
    size: 24,
    fontSize: 9,
  },
  medium: {
    size: 32,
    fontSize: 10,
  },
  large: {
    size: 40,
    fontSize: 10,
  },
  xlarge: {
    size: 64,
    fontSize: 17,
  },
  xxlarge: {
    size: 270,
    fontSize: 48,
  },
  default: {
    size: 48,
    fontSize: 11,
  },
};

const GroupAvatarFontSizes: Record<AvatarSize | "default", { fontSize: number }> = {
  small: {
    fontSize: 9,
  },
  medium: {
    fontSize: 10,
  },
  large: {
    fontSize: 15,
  },
  xlarge: {
    fontSize: 17,
  },
  xxlarge: {
    fontSize: 48,
  },
  default: {
    fontSize: 16,
  },
};

export const getAvatarSize = (size?: AvatarSize) => AvatarSizes[size ?? "default"];
export const getGroupAvatarSize = (size?: AvatarSize) => ({
  ...AvatarSizes[size ?? "default"],
  ...GroupAvatarFontSizes[size ?? "default"],
});

export const avatarSizeToPx = (size: AvatarSize | undefined, isGroupAvatar?: boolean): number => {
  if (isGroupAvatar) {
    return getGroupAvatarSize(size).size;
  }
  return getAvatarSize(size).size;
};

export const avatarSizeToFontSize = (size: AvatarSize | undefined, isGroupAvatar?: boolean): number => {
  if (isGroupAvatar) {
    return getGroupAvatarSize(size).fontSize;
  }
  return getAvatarSize(size).fontSize;
};
